import { Divider, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { HomeContext } from "../containers/Home";
import useContainerDimensions from "../hooks/useContainerDimensions";
import useHandleContextMenu from "../hooks/useHandleContextMenu";
import { TPermission } from "../types/pemission";
import { TProjectData } from "../types/project";
import { GetAntIcon } from "../utils/ant_icons";
import { setLookupData } from "../utils/lookupFinder";
import AuditLogModal from "./Modal/AuditLogModal";
import SearchButton from "./SearchButton";
import AuditLogButton from "./AuditLogButton";

function ProjectDetailsDrawer({
	projectData,
	permissions,
}: {
	projectData: TProjectData;
	permissions: TPermission;
}) {
	const [projectDetailsExpand, setProjectDetailsExpand] = useState(false);
	const [auditOpen, setAuditOpen] = useState(false);
	const [dataTable, setDataTable] = useState<any>(projectData.role_assignments);
	const [filteredDataTable, setFilteredDataTable] = useState<any>(null);
	const [searchRecord, setSearchRecord] = useState<any>([]);
	const [tempRecord, setTempRecord] = useState<any>(null);

	const navigate = useNavigate();
	const { handleContextMenu } = useHandleContextMenu();

	// Reference to the panel container
	const [panelRef, panelDimensions] = useContainerDimensions();

	const { currentTenantKey, allData }: any = useContext(HomeContext);

	const handleSearch = (record: any) => {
		setTempRecord(record);
	};

	useEffect(() => {
		if (searchRecord && tempRecord) {
			const recordIndex = searchRecord.findIndex((item: any) => {
				return item.columnKey === tempRecord.columnKey;
			});
			if (recordIndex !== -1) {
				if (tempRecord.value != "") {
					const _record = [...searchRecord];
					_record[recordIndex] = tempRecord;
					setSearchRecord(_record);
				} else {
					const _record = [...searchRecord];
					_record.splice(recordIndex, 1);
					setSearchRecord(_record);
				}
			} else {
				if (tempRecord.value != "") {
					const _record = [...searchRecord];
					_record.push(tempRecord);
					setSearchRecord(_record);
				}
			}
		}
	}, [tempRecord]);

	useEffect(() => {
		if (searchRecord?.length > 0) {
			let data: any = [];

			data = [...dataTable];
			console.log(searchRecord);
			const filteredData = data
				?.map((element: any) => {
					const bool = searchRecord.every((item: any) => {
						if (Array.isArray(element[item.columnKey])) {
							return element[item.columnKey].some((arrayItem: any) =>
								arrayItem.toLowerCase().includes(item.value.toLowerCase())
							);
						} else {
							return element[item.columnKey]
								?.toLowerCase()
								.includes(item.value.toLowerCase());
						}
					});
					if (bool) return element;
				})
				.filter((element: any) => element !== null && element !== undefined);
			setFilteredDataTable(filteredData);
		} else {
			setFilteredDataTable(null);
		}
	}, [searchRecord]);

	const columns = [
		{
			title: (
				<SearchButton
					handleSearch={handleSearch}
					headerName="Team role"
					columnKey="role"
					key={"y" + "role"}
				/>
			),
			dataIndex: "role",
			key: "role",
			render: (_: any, record: any) => {
				// Check if the role is "general_member", then render as General Member
				if (record.role_id === "general_member") {
					return <span>General members</span>;
				}
				if (record.role_id === "main_approver") {
					return <span>Main Approver</span>;
				}
				if (record.role_id === "secondary_approver") {
					return <span>Secondary Approver</span>;
				}
				// The role name is stored on the record itself
				return <span>{record.role}</span>;
			},
		},
		{
			title: (
				<SearchButton
					handleSearch={handleSearch}
					headerName="Assigned to" // Column title
					columnKey="appointee" // Unique key for search
					key={"x" + "appointee"}
				/>
			),
			dataIndex: "appointee",
			render: (_: any, record: any) =>
				record["appointee"]?.map((name: any) => {
					return (
						<>
							<span>{name}</span>
							<br />
						</>
					);
				}),
			key: "appointee",
		},
	];

	const renderDetailData = () => {
		const projectTemplateExample: any = [
			{ label: "Project title", key: "project_name", value: "name" },
			{ label: "Project type", key: "project_type", value: "type" },
			{ label: "Project area", key: "project_area", value: "area" },
			{ label: "Project code", key: "project_code", value: "ABC123456A" },
			{ label: "Owner/Operator", key: "client", value: "Addax Petroleum" },
			{ label: "Region", key: "region", value: "North Europe" },
			{ label: "Country", key: "country", value: "England" },
			{ label: "Operating office", key: "operating_office", value: "Aberdeen" },
		];

		const renderProjectTags = () => {
			return (
				<div
					style={{
						display: "grid",
						rowGap: "6px",
						gridTemplateRows: "auto auto",
						gridColumn: "span 3",
					}}
				>
					<span
						className="panel-detail-label"
						style={{
							// color: "rgba(255, 255, 255, 0.45)",
							display: "flex",
							justifyContent: "flex-start",
							fontSize: "12px",
						}}
					>
						Project tags
					</span>
					<span
						style={{
							display: "flex",
							flexWrap: "wrap",
							fontSize: "14px",
							rowGap: "10px",
						}}
					>
						{setLookupData(allData, projectData, "project_tags")}
					</span>
				</div>
			);
		};

		return (
			<div
				className="meta-data-container"
				style={{ gridTemplateColumns: "repeat(3, auto)" }}
			>
				{projectTemplateExample.map((element: any) => (
					<div
						style={{
							display: "grid",
							gridTemplateRows: "20px auto",
							gridRow: element.label === "Country" ? "span 2" : undefined,
						}}
					>
						<span className="panel-detail-label">{element.label}</span>
						<span className="panel-item-content">
							{setLookupData(allData, projectData, element.key)}
						</span>
					</div>
				))}
				{renderProjectTags()}
			</div>
		);
	};

	return (
		<>
			<div
				className="main-container"
				style={{ width: "100%", marginBottom: "20px" }}
			>
				<div
					className="container-header"
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<div
						className="panel-info"
						onClick={() => {
							setProjectDetailsExpand(!projectDetailsExpand);
						}}
					>
						<span>Project details</span>
						{projectDetailsExpand ? GetAntIcon("up") : GetAntIcon("downarrow")}
					</div>
					<div className="panel-main-buttons-container">
						{(permissions.hasEditProjectPermission ||
							permissions.hasDeleteProjectPermission) && (
							<a
								onClick={() => {
									navigate("project-settings", {
										replace: false,
										state: { ...projectData },
									});
								}}
								onContextMenu={(event: any) => {
									const location = `${window.location.href}/project-settings`;
									handleContextMenu(event, { link: location });
								}}
							>
								{GetAntIcon("setting")} Project settings
							</a>
						)}
						<AuditLogButton
							moduleKey="project-delivered"
							handleClick={() => {
								setAuditOpen(true);
							}}
						/>
					</div>
				</div>
				<div
					className="details-content project-details-container"
					style={{
						display: projectDetailsExpand ? "flex" : "none",
						flexWrap: "inherit",
						flexDirection: "row",
						alignItems: "flex-start",
						justifyContent: "space-between",
						padding: "30px",
						gap: 0,
						overflowX: "auto",
						maxHeight: "100%",
					}}
				>
					<div className="project-details-content" ref={panelRef}>
						{renderDetailData()}
					</div>
					<Divider
						type="vertical"
						style={{ height: "100%", margin: "0px 20px" }}
					></Divider>
					<div
						style={{
							width: "708px",
							borderLeft: "1px solid rgba(255, 255, 255, 0.15)", // 0.15 = 15% opacity
							padding: "0px 20px 10px 20px",
						}}
					>
						<div
							id="table-container"
							style={{
								flex: 1,
								width: "100%",
								maxHeight: "100%",
								overflow: "hidden",
							}}
						>
							<Table
								rootClassName="m"
								pagination={false}
								scroll={{
									y: panelDimensions.height - 64.8,
									x: 0,
								}}
								dataSource={filteredDataTable || dataTable}
								columns={columns}
							/>
						</div>
					</div>
				</div>
			</div>
			<AuditLogModal
				label="Project"
				tenantKey={currentTenantKey}
				identifierKeys={{ project_code: projectData?.project_code }}
				open={auditOpen}
				type={"project"}
				handleClose={() => {
					setAuditOpen(false);
				}}
			/>
		</>
	);
}

export default ProjectDetailsDrawer;
